import React, { Component } from 'react'; 
import {Row} from 'react-bootstrap';
import _ from 'lodash';

export default class NewElement extends Component {
  constructor(props){
    super(props)
    this.state ={
      selected:props? props.value.label :''
    }
  }
  handleSelectParameters = (e) => {
    //const{propindex, attibindex, questindex} = this.props;
    this.setState({selected:e.target.value})
    let val = _.cloneDeep(this.props.value)
    val.label = e.target.value;
    let objects = _.filter(this.props.payload, {'status':'ACTIVE'}) 
    let obj = _.find(objects, {'label':e.target.value}) 
    if(!_.isEmpty(obj) && _.has(obj, 'id')){
      val['id'] = obj.id
    }
    this.props.Callback(val, this.props.index)
  }
 
  
  render(){
    const{payload, id} = this.props;
    let objects = _.filter(payload, {'status':'ACTIVE'})     
    const{selected} = this.state;
    return(
      <Row className='formQuestion'>
        <select disabled={this.props.disabled}  className='auditForm' id={id} onChange={this.handleSelectParameters} >
            <option selected={selected === ""} value="">Select {id}</option>
            <option id='NA' selected={selected === "-"} value="-">Not Applicable</option>
            { _.map(objects, (obj, i)=> {
              return(<option   selected={_.isEqual(selected,obj.label)} id={obj.id} value={obj.label}>{obj.label}</option>)
            
            })}
        </select>
      </Row>
      
    )
  }
}
